import { render } from "./AFooter.vue?vue&type=template&id=57de0d94"
import script from "./AFooter.vue?vue&type=script&lang=ts"
export * from "./AFooter.vue?vue&type=script&lang=ts"

import "./AFooter.vue?vue&type=style&index=0&id=57de0d94&lang=postcss"
script.render = render

export default script